/**
 * @param {RawPlanPickerItem} rawItem
 * @returns {PlanPickerItem}
 */
export const normalizeItem = rawItem => {
    return {
        status: 'loaded',
        kind: parseItemKind(rawItem),
        id: rawItem.id,
        name: rawItem.n,
        moneyValue: rawItem.b,
        isDisabled: rawItem.c.endsWith('Disabled')
    };
};

/**
 * @param {RawPlanPickerItem} rawItem
 * @returns {PlanPickerItem['kind']}
 */
export const parseItemKind = rawItem => {
    if (rawItem.c.startsWith('planDropDownItemCompany')) {
        return 'company';
    } else if (rawItem.c.startsWith('planDropDownItemPlan')) {
        return 'plan';
    } else {
        return 'unknown';
    }
};

/** @type {(option: import('./usePlanPickerApi/items').PlanPickerItemWithStatus) => string} */
export const getOptionLabel = option => {
    if (option.status === 'loaded') {
        return option.name;
    } else {
        return `Loading option ${option.ix + 1}`;
    }
};

/** @type {(option: import('./usePlanPickerApi/items').PlanPickerItemWithStatus) => string} */
export const getOptionValue = option => {
    if (option.status === 'loaded') {
        return option.id;
    } else {
        return `virtual-option-${option.ix}`;
    }
};

/** @type {(option: import('./usePlanPickerApi/items').PlanPickerItemWithStatus) => boolean} */
export const isOptionDisabled = option => {
    if (option.status === 'loaded') {
        return option.isDisabled;
    } else {
        return true;
    }
};

/**
 * @typedef {object} RawPlanPickerItem
 * @prop {string} id
 * @prop {string} c a combination of kind ("company" or "plan") and disabled status
 * @prop {string} n item name
 * @prop {string} b money value
 */

/**
 * @typedef {object} PlanPickerItem
 * @prop {'loaded'} status
 * @prop {'company' | 'plan' | 'unknown'} kind
 * @prop {string} id
 * @prop {string} name
 * @prop {string} moneyValue
 * @prop {boolean} isDisabled
 */

/** @typedef {VirtualPlanPickerItem | import('./items').PlanPickerItem} PlanPickerItemWithStatus */
/** @typedef {{ status: 'loading' | 'unloaded', ix: import('./pagination').Index }} VirtualPlanPickerItem */
